import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
export const Context = React.createContext();
export const ContextAll = React.createContext();
export default function SaveFile({ children }) {
  let { pathname } = useLocation();
  const [contextValue, setContextValue] = useState({});
  const [savePdf, setSavePdf] = useState();
  const [saveAudio, setSaveAudio] = useState();
  const [savePptx, setSavePptx] = useState();
  const [saveGallery, setSaveGallery] = useState([]);
  const [savePcr, setSavePcr] = useState(["", "", ""]);
  const [saveWifi, setSaveWifi] = useState();
  const [saveText, setSaveText] = useState("");
  const [saveVCardFile, setSaveVCardFile] = useState([]);
  const [savePng, setSavePng] = useState([]);
  const [saveFile, setSaveFile] = useState([]);
  const [saveExcelFile, setExcelSaveFile] = useState();
  const [settingsFile, setSettingsFile] = useState([]);

  useEffect(() => {
    if (pathname.includes("/pdf")) {
      setContextValue({ savePdf, setSavePdf });
    }
    if (pathname.includes("/audio")) {
      setContextValue({ saveAudio, setSaveAudio });
    }
    if (pathname.includes("/pptx")) {
      setContextValue({ savePptx, setSavePptx });
    }
    if (pathname.includes("/image")) {
      setContextValue({ saveGallery, setSaveGallery });
    }
    if (pathname.includes("/pcr")) {
      setContextValue({ savePcr, setSavePcr });
    }
    if (pathname.includes("/wi-fi")) {
      setContextValue({ saveWifi, setSaveWifi });
    }
    if (pathname.includes("/text")) {
      setContextValue({ saveText, setSaveText });
    }
    if (pathname.includes("/vcard")) {
      setContextValue({ saveVCardFile, setSaveVCardFile });
    }
    if (pathname.includes("/png")) {
      setContextValue({ savePng, setSavePng });
    }
    if (pathname.includes("/file")) {
      setContextValue({ saveFile, setSaveFile });
    }
    if (pathname.includes("/excel")) {
      setContextValue({ saveExcelFile, setExcelSaveFile });
    }
    if (pathname.includes("/entry/settings")) {
      setContextValue({ settingsFile, setSettingsFile });
    }
  }, [pathname]);
  return (
    <ContextAll.Provider
      value={{
        setSavePdf,
        setSaveAudio,
        setSavePptx,
        setSaveGallery,
        setSavePcr,
        setSaveWifi,
        setSaveText,
        setSaveVCardFile,
        setSavePng,
        setSaveFile,
        setExcelSaveFile,
        setSettingsFile,
        settingsFile,
      }}
    >
      <Context.Provider value={contextValue}>{children}</Context.Provider>
    </ContextAll.Provider>
  );
}
